import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/d6b45feb-4d52-48ce-83a1-835df5fc6b97";
export const REGISTER_URL = "https://a.ntrk2.com/02e9c1cf-3c8c-4b85-ac46-5ab8c8e86419";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://winkph.kzw2a.com/download?openExternalBrowser=1&id=iv9huhrhukgsazk";

export * from "./codes";
export * from "./context";
